module.exports = __webpack_public_path__ + "img/bingo-canto.6cafe65c.png";